/** `/app/map` search params (FE-06 §6.1, §20): filters, text, selected place and view live in the URL. */

export interface MapSearch {
  web?: "none" | "all";
  marks?: 1;
  zone?: string;
  /** Legacy category chip; kept for links made before the niche data (BE-07 §15). */
  category?: string;
  /** Taxonomy family id (FR-FE06-59). */
  family?: string;
  /** Taxonomy niche id (FR-FE06-59). */
  niche?: string;
  q?: string;
  place?: string;
  view?: "map" | "list";
  /** FE-18 FR-FE18-13: open the create form prefilled from this lead dossier. */
  leadId?: string;
}

function text(value: unknown, max = 200): string | undefined {
  if (typeof value !== "string" && typeof value !== "number") return undefined;
  const s = String(value).slice(0, max);
  return s ? s : undefined;
}

/** Taxonomy ids are snake_case slugs (`comida_y_bebida`, `tienda_de_ropa`). */
function slug(value: unknown): string | undefined {
  return typeof value === "string" && /^[a-z0-9_]{1,60}$/.test(value) ? value : undefined;
}

export function parseMapSearch(raw: Record<string, unknown>): MapSearch {
  const out: MapSearch = {};
  if (raw.web === "all" || raw.web === "none") out.web = raw.web;
  if (raw.marks === "1" || raw.marks === 1 || raw.marks === true) out.marks = 1;
  const zone = text(raw.zone);
  if (zone) out.zone = zone;
  const category = text(raw.category);
  if (category) out.category = category;
  const family = slug(raw.family);
  if (family) out.family = family;
  // A niche only means something inside its family.
  const niche = family ? slug(raw.niche) : undefined;
  if (niche) out.niche = niche;
  const q = text(raw.q);
  if (q) out.q = q;
  const place = text(raw.place, 300);
  if (place) out.place = place;
  if (raw.view === "map" || raw.view === "list") out.view = raw.view;
  const leadId = slug(raw.leadId) ?? text(raw.leadId, 60);
  if (leadId) out.leadId = leadId;
  return out;
}
